import { Box, Flex, Text, Divider, VStack } from "@chakra-ui/react";
import { CheckCircleIcon, TimeIcon, WarningIcon } from "@chakra-ui/icons";
import { GRUPOS_OFERTA_CUSTOM_STATUS } from "@/utils/consignado/ofertaEscolhida";

type Status = "aguardando" | "sucesso" | "erro" | "cancelado";

interface Step {
  status: Status;
  mensagem: string;
}

interface Section {
  [key: string]: Step;
}

const statusIcon: Record<Status, JSX.Element> = {
  cancelado: <WarningIcon color="red.500" boxSize={6} />,
  sucesso: <CheckCircleIcon color="green.500" boxSize={6} />,
  aguardando: <TimeIcon color="blue.400" boxSize={6} />,
  erro: <WarningIcon color="red.500" boxSize={6} />,
};

const sectionTitles: Record<string, string> = {
  confirmacao: "Confirmação",
  formalizacao: "Formalização",
  pagamento: "Pagamento",
  cancelamento: "Cancelamento",
  acoes: "Ações",
  averbacao: "Averbação",
};

interface CreditAuctionProposalLogsProps {
  logsStr: string;
}

export function CreditAuctionProposalLogs({ logsStr }: CreditAuctionProposalLogsProps) {
  let logs: any = null;
  
  try {
    logs = JSON.parse(logsStr);
  } catch (err) {
    return null;
  }

  if (!logs || typeof logs !== "object") return null;

  const getSectionTitle = (sectionKey: string): string => {
    return sectionTitles[sectionKey] || sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1);
  };

  const renderSection = (sectionName: string, sectionLogs: Section): JSX.Element | null => {
    const validEntries = Object.entries(sectionLogs).filter(
      ([, step]) => step && typeof step === "object" && step.status && step.mensagem
    );

    if (validEntries.length === 0) return null;

    return (
      <Box key={sectionName} width="100%" mt={4}>
        <Text fontWeight="bold" fontSize="lg" color="blue.600" mb={2} fontFamily="Lexend Deca">
          {getSectionTitle(sectionName)}
        </Text>

        <VStack align="start" spacing={2}>
          {validEntries.map(([key, step]) => (
            <Flex key={key} align="center" gap={2}>
              {statusIcon[step.status] || <WarningIcon color="gray.500" boxSize={6} />}
              <Text fontFamily="Lexend Deca">
                {step.mensagem}
              </Text>
            </Flex>
          ))}
        </VStack>
        <Divider mt={2} />
      </Box>
    );
  };

  return (
    <VStack align="start" spacing={6} width="100%">
      {Object.entries(logs)
        .filter(([sectionName]) => !(GRUPOS_OFERTA_CUSTOM_STATUS as readonly string[]).includes(sectionName))
        .map(([sectionName, sectionLogs]) =>
          sectionLogs && typeof sectionLogs === "object"
            ? renderSection(sectionName, sectionLogs as Section)
            : null
        )}
    </VStack>
  );
}
